<template lang="pug">
  v-container(fluid)
    //- h2.text-center {{ translations.title }}
    h2.text-center Freerounds
    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12" md="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        )
          template(v-slot:item="{ item }")
            tr
              td
                span {{ item.name }}
              td
                span {{ item.startdate }}, {{ item.enddate }}
              td
                span {{ item.provider }}
              td
                FreeroundsEditDialog(:title="'Detalles: ' + item.name" button="ver detalles", :freerounds="item")
              td
                BaseConfirmDialog(v-bind="translations.confirmationDialog.status" @confirm="toggleState(item.id)")
                  template(v-slot="{ on }")
                    v-btn(v-on="on", :color="getColor(item.status.value)", :loading="loadingToggleFreerounds" dark rounded) {{ item.status.text }}
    BaseDialog(v-if="hasPermission('views.casino.freerounds.createFreerounds')" type="create", title="Crear campaña Freerounds" v-slot="{close, opened}")
      FreeroundsCreate(@successCreate="updateFreerounds(opened,close)", :clearForm="opened", :translations="translationsForm")

</template>

<script>

  import FreeroundsCreate from '@/views/campaigns/Freerounds/forms/FreeroundsCreate';
  import FreeroundsEditDialog from '@/components/dialogs/edit/FreeroundsEditDialog';
  import { mockup } from './mockup.js';

  export default {
    name: "FreeroundsIndex",
    components: {
      FreeroundsCreate,
      FreeroundsEditDialog,
    },
    // data: () => ({
    // }),
    computed:{
      translations() {
        return this.$t("views.freeroundsIndex");
      },
      translationsForm() {
        return this.$t("forms.freerounds");
      },
      headers() {
        let headers = [
          {
            text: 'Nombre',
            value: 'name'
          },
          {
            text: 'Fechas',
            value: 'date'
          },
          {
            text:'Proveedor',
            value:'provider'
          },
          {
            text: '',
            value: '',
            sortable: false
          },
          {
            text: '',
            value: '',
            sortable: false
          }
        ];
        return headers;
      },
      datos(){
        // const vm = this;
        // return this.competitionListAll.map(competition =>{
        //   return {
        //     _id: competition._id,
        return mockup;
      },
      loadingToggleFreerounds(){
        return this.$store.state.statusCode.toggleFreerounds.loading;
      },
      statusToggleState(){
        return this.$store.state.statusCode.toggleFreerounds.state || '';
      },
      freeroundsListAll() {
        return this.$store.state.freerounds;
      },
    },
    watch: {
      statusToggleState: function (val) {
        if (val == 200) {
          this.$store.dispatch('getFreerounds');
        }
      },
    },
    created() {
      this.$store.dispatch('getFreerounds');
    },
    methods: {
      getColor(type){
        return type ? 'green': 'red';
      },
      toggleState(freeroundsId){
        this.$store.dispatch('toggleFreerounds', freeroundsId);
      },
      updateFreerounds(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getFreerounds');
        }
      },
    },
  }
</script>

<style lang="sass">
</style>